import { SortDefinition } from '@shared/models/sort-definition';

export interface ModaliteState {
  paginator: { pageNb: number; pageSize: number };
  sort: SortDefinition;
}

export const initialState: ModaliteState = {
  paginator: { pageNb: 1, pageSize: 20 },
  sort: { direction: '+', nom: 'nom' },
};
